import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import {
  differenceInDays,
  differenceInHours,
  differenceInMinutes,
  differenceInSeconds,
  isAfter,
} from "date-fns";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getCdnUrl(path: string): string {
  const host =
    import.meta.env.CDN_HOST ||
    "https://sharkroll-casino-prod.s3.eu-west-1.amazonaws.com/";

  return `${host}${path}`;
}

export const calculateTimeDifference = (dateString: any) => {
  const currentDate = new Date();
  const givenDate = new Date(dateString);

  if (isAfter(givenDate, currentDate)) {
    const days = differenceInDays(givenDate, currentDate);
    const hours = differenceInHours(givenDate, currentDate) % 24;
    const minutes = differenceInMinutes(givenDate, currentDate) % 60;
    const seconds = differenceInSeconds(givenDate, currentDate) % 60;

    return { days, hours, minutes, seconds };
  } else {
    return { days: 0, hours: 0, minutes: 0, seconds: 0 };
  }
};
